import {useNotification} from 'hooks/useNotification'
import {useContext, useEffect, useState} from 'react'
import feathers from 'utility/client'
import {NavigationContext} from 'modules/dashboard/NavigationContext'

export const Export = props => {
  const notify = useNotification()
  const {setTitle} = useContext(NavigationContext)
  const [requesting, setRequesting] = useState(false)

  useEffect(() => {
    setTitle('Export Device Data')
  }, [])

  const onRequest = () => {
    setRequesting(true)
    feathers.io.emit('export', 'device', {}, {}, (e, response) => {
      setRequesting(false)
      if (e) {
        notify({
          notification: 'Export could not be processed, Please try again!',
          variant: 'danger'
        })
        return
      }

      notify({
        notification: `Export has been requested, You'll soon get a email.`,
        variant: 'success'
      })
    })
  }

  return (
    <>
      <div className="table-responsive-mask">
        <div className="table-responsive">
          <div className="text-center">
            <button type="button" className="btn btn-primary" onClick={onRequest}>
              {
                requesting ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="sr-only">...</span>
                  </div>
                ) : (
                  <span>
                    Request Data Export
                  </span>
                )
              }
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
